import { render, staticRenderFns } from "./OrderViewActionsSpecPaymentError.vue?vue&type=template&id=5852a578&"
import script from "./OrderViewActionsSpecPaymentError.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsSpecPaymentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports